<template>
    <div class="content-section">
        <div class="content-section-heading">
            {{ this.trans('emails.index.reminder_mail')}}
        </div>

        <div class="content-row">
            <alert type="info">
                {{infoText}}
            </alert>
        </div>
        <div class="content-row content-row--space-between">
            <a :href='url'>
                <button class="btn btn--big btn--primary" v-text="text"></button>
            </a>
            <button class="btn btn--big btn--secondary" @click="ComfirmAndDelete" v-if="show">
                {{ this.trans('emails.button.reminder_mail.delete') }}
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['client', 'mailConfigExist'],

        data() {
            return {
                show: !!this.mailConfigExist
            }
        },

        computed: {
            url() {
                return this.show ? this.route('tenant.clients.mail_reminder_config.show', this.client.id)
                    : this.route('tenant.clients.mail_reminder_config.create', this.client.id)
            },

            text() {
                return this.show ? this.trans('emails.button.reminder_mail.edit') : this.trans('emails.button.reminder_mail.create')
            },

            infoText() {
                return this.show? this.trans('emails.label.specific_config'): this.trans('emails.label.no_specific_config')
            }
        },

        methods: {
            ComfirmAndDelete() {
                this.$alertify.confirmWithTitle(
                    this.trans('emails.note.delete_title'),
                    this.trans('emails.note.delete_message'),
                    () => {
                        axios
                            .delete(this.route('tenantapi.clients.mail_reminder_config.destroy', this.client.id))
                            .then( response => {
                                this.show = false
                                this.flash({
                                    message: response.data.flash[0].message,
                                    level: 'success'
                                });
                            })
                        }
                )
            }
        }
    }
</script>
